/**
 * Lanificio Trade — horizontale rijen (van dichtbij, toepassingen, collectie).
 * De rij zelf is een gewone horizontale scroller met scroll-snap: swipen en
 * trackpad werken native. Dit script voegt alleen de pijlen toe voor
 * apparaten met een muis, en zet ze uit aan het begin en eind van de rij.
 * Zonder pijlen in de HTML (data-arrows) doet het niets.
 */
(() => {
  if (customElements.get('lan-trade-slider')) return;

  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  class LanTradeSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.arrows = this.querySelector('[data-arrows]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (!this.track || !this.arrows || !this.prev || !this.next) return;

      this.update = this.update.bind(this);
      this.toggleArrows = this.toggleArrows.bind(this);
      this.prev.addEventListener('click', () => this.go(-1));
      this.next.addEventListener('click', () => this.go(1));
      this.track.addEventListener('scroll', this.update, { passive: true });
      finePointer.addEventListener('change', this.toggleArrows);
      this.resizeObserver = new ResizeObserver(this.toggleArrows);
      this.resizeObserver.observe(this.track);
      this.toggleArrows();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.update);
      finePointer.removeEventListener('change', this.toggleArrows);
      this.resizeObserver?.disconnect();
    }

    /** Pijlen alleen met muis, en alleen als er echt iets te scrollen valt. */
    toggleArrows() {
      const overflows = this.track.scrollWidth > this.track.clientWidth + 1;
      this.arrows.hidden = !(finePointer.matches && overflows);
      this.update();
    }

    /** Eén kaart verder of terug (breedte van een kaart plus de gap). */
    go(direction) {
      const item = this.track.firstElementChild;
      if (!item) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * (item.getBoundingClientRect().width + gap) });
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max - 2;
    }
  }

  customElements.define('lan-trade-slider', LanTradeSlider);
})();
